jQuery(function ($) {
    $('.btn-print-brochure').on('click', function () {
        $('.e-n-accordion-item').each(function () {
            $(this).attr('open', '');
        });
        window.print();
    });
});
